import React from 'react'
import { OverSection } from 'src/pages/Home/styles'
import {
    Content,
    SectionOurTeam,
    ImageCompany,
    ContentInformation,
    ContentButton,
    TypographyTitleSection,
    SectionTeam,
    TypographyContent,
} from './styles'
import Company from 'src/assets/MeetOurTeam/Company.avif'
import { TypographyTitle } from 'src/components/common/Typography/typography'
import { MeetOurTeamLabels } from 'src/constants'
import { MapTeam } from './mapTeam'
import { useAnimation } from 'src/hook'
import { rightVariant, scaleVariantTitle } from 'src/theme/animations/swipeIn'
import { useTranslations } from 'src/provider/LocaleProvider'
import { ROUTES } from 'src/navigation'

export const MeetOurTeam = () => {
    const t = useTranslations()
    const { control, ref } = useAnimation({ initialSpriteIdTitle: 2 })
    const { MeetOurTeamInformation } = MeetOurTeamLabels()

    return (
        <OverSection paddingTop={'titlle'} paddingBottom={'titlle'} ref={ref}>
            <TypographyTitle
                variant={'h1'}
                fontSize={['xxxlarge', 'xxxlarge', 'xxxlarge', 'titlle']}
                fontWeight={600}
                initial="hidden"
                animate={control}
                variants={scaleVariantTitle}
            >
                {t('meetOurTeam.title')}
            </TypographyTitle>
            <Content marginTop={['xlarge', 'xlarge', 'xlarge', 'xsixty']}>
                <SectionOurTeam
                    initial="hidden"
                    animate={control}
                    variants={rightVariant}
                >
                    <ContentInformation
                        marginTop={[
                            'xmedium',
                            'xmedium',
                            'xxxmedium',
                            'xxxmedium',
                        ]}
                        paddingRight={[
                            'xmedium',
                            'xmedium',
                            'xxlarge',
                            'xxlarge',
                        ]}
                        marginBottom={[
                            'xmedium',
                            'xmedium',
                            'xxxmedium',
                            'xxxmedium',
                        ]}
                        marginLeft={[
                            'xxmedium',
                            'xxmedium',
                            'xxlarge',
                            'xxlarge',
                        ]}
                    >
                        <ImageCompany src={Company} alt={'Company'} />
                        <TypographyTitleSection
                            variant={'h1'}
                            fontSize={[
                                'xxxmedium',
                                'xxxmedium',
                                'xxxmedium',
                                'titlle',
                            ]}
                            fontWeight={600}
                        >
                            {t('meetOurTeam.title')}
                        </TypographyTitleSection>
                        <TypographyContent
                            variant={'h2'}
                            fontSize={[
                                'xsmall',
                                'xsmall',
                                'xsmall',
                                'xxxsmall',
                            ]}
                            fontWeight={400}
                        >
                            {t('meetOurTeam.content')}
                        </TypographyContent>
                        <ContentButton to={ROUTES.TEAM}>
                            {t('cta.goToTeam')}
                        </ContentButton>
                    </ContentInformation>
                </SectionOurTeam>
                <SectionTeam>
                    {MeetOurTeamInformation.slice(0, 4).map((team) => {
                        return <MapTeam key={team.id} {...team} />
                    })}
                </SectionTeam>
            </Content>
        </OverSection>
    )
}
